if (!customElements.get("countries-selector")) {
    let curent_country = window.localStorage.getItem('country')?.toLocaleUpperCase() || Shopify.country;
    const cmap = {
        EU: "EUR",
        BD: "BDT",
        BE: "EUR",
        BF: "XOF",
        BG: "EUR",
        BA: "BAM",
        BB: "BBD",
        WF: "XPF",
        BL: "EUR",
        BM: "BMD",
        BN: "BND",
        BO: "BOB",
        BH: "BHD",
        BI: "BIF",
        BJ: "XOF",
        BT: "BTN",
        JM: "JMD",
        BV: "NOK",
        BW: "BWP",
        WS: "WST",
        BQ: "USD",
        BR: "BRL",
        BS: "BSD",
        JE: "GBP",
        BY: "BYR",
        BZ: "BZD",
        RU: "RUB",
        RW: "RWF",
        RS: "RSD",
        TL: "USD",
        RE: "EUR",
        TM: "TMT",
        TJ: "TJS",
        RO: "RON",
        TK: "NZD",
        GW: "XOF",
        GU: "USD",
        GT: "GTQ",
        GS: "GBP",
        GR: "EUR",
        GQ: "XAF",
        GP: "EUR",
        JP: "JPY",
        GY: "GYD",
        GG: "GBP",
        GF: "EUR",
        GE: "GEL",
        GD: "XCD",
        GB: "GBP",
        GA: "XAF",
        SV: "USD",
        GN: "GNF",
        GM: "GMD",
        GL: "DKK",
        GI: "GIP",
        GH: "GHS",
        OM: "OMR",
        TN: "TND",
        JO: "JOD",
        HR: "EUR",
        HT: "HTG",
        HU: "HUF",
        HK: "HKD",
        HN: "HNL",
        HM: "AUD",
        VE: "VES",
        PR: "USD",
        PS: "ILS",
        PW: "USD",
        PT: "EUR",
        SJ: "NOK",
        PY: "PYG",
        IQ: "IQD",
        PA: "PAB",
        PF: "XPF",
        PG: "PGK",
        PE: "PEN",
        PK: "PKR",
        PH: "PHP",
        PN: "NZD",
        PL: "PLN",
        PM: "EUR",
        ZM: "ZMK",
        EH: "MAD",
        EE: "EUR",
        EG: "EGP",
        ZA: "ZAR",
        EC: "USD",
        IT: "EUR",
        VN: "VND",
        SB: "SBD",
        ET: "ETB",
        SO: "SOS",
        ZW: "ZWL",
        SA: "SAR",
        ES: "EUR",
        ER: "ERN",
        ME: "EUR",
        MD: "MDL",
        MG: "MGA",
        MF: "EUR",
        MA: "MAD",
        MC: "EUR",
        UZ: "UZS",
        MM: "MMK",
        ML: "XOF",
        MO: "MOP",
        MN: "MNT",
        MH: "USD",
        MK: "MKD",
        MU: "MUR",
        MT: "EUR",
        MW: "MWK",
        MV: "MVR",
        MQ: "EUR",
        MP: "USD",
        MS: "XCD",
        MR: "MRO",
        IM: "GBP",
        UG: "UGX",
        TZ: "TZS",
        MY: "MYR",
        MX: "MXN",
        IL: "ILS",
        FR: "EUR",
        IO: "USD",
        SH: "SHP",
        FI: "EUR",
        FJ: "FJD",
        FK: "FKP",
        FM: "USD",
        FO: "DKK",
        NI: "NIO",
        NL: "EUR",
        NO: "NOK",
        NA: "NAD",
        VU: "VUV",
        NC: "XPF",
        NE: "XOF",
        NF: "AUD",
        NG: "NGN",
        NZ: "NZD",
        NP: "NPR",
        NR: "AUD",
        NU: "NZD",
        CK: "NZD",
        XK: "EUR",
        CI: "XOF",
        CH: "CHF",
        CO: "COP",
        CN: "CNY",
        CM: "XAF",
        CL: "CLP",
        CC: "AUD",
        CA: "CAD",
        CG: "XAF",
        CF: "XAF",
        CD: "CDF",
        CZ: "CZK",
        CY: "EUR",
        CX: "AUD",
        CR: "CRC",
        CW: "XCG",
        CV: "CVE",
        CU: "CUP",
        SZ: "SZL",
        SY: "SYP",
        SX: "XCG",
        KG: "KGS",
        KE: "KES",
        SS: "SSP",
        SR: "SRD",
        KI: "AUD",
        KH: "KHR",
        KN: "XCD",
        KM: "KMF",
        ST: "STD",
        SK: "EUR",
        KR: "KRW",
        SI: "EUR",
        KP: "KPW",
        KW: "KWD",
        SN: "XOF",
        SM: "EUR",
        SL: "SLL",
        SC: "SCR",
        KZ: "KZT",
        KY: "KYD",
        SG: "SGD",
        SE: "SEK",
        SD: "SDG",
        DO: "DOP",
        DM: "XCD",
        DJ: "DJF",
        DK: "DKK",
        VG: "USD",
        DE: "EUR",
        YE: "YER",
        DZ: "DZD",
        US: "USD",
        UY: "UYU",
        YT: "EUR",
        UM: "USD",
        LB: "LBP",
        LC: "XCD",
        LA: "LAK",
        TV: "AUD",
        TW: "TWD",
        TT: "TTD",
        TR: "TRY",
        LK: "LKR",
        LI: "CHF",
        LV: "EUR",
        TO: "TOP",
        LT: "EUR",
        LU: "EUR",
        LR: "LRD",
        LS: "LSL",
        TH: "THB",
        TF: "EUR",
        TG: "XOF",
        TD: "XAF",
        TC: "USD",
        LY: "LYD",
        VA: "EUR",
        VC: "XCD",
        AE: "AED",
        AD: "EUR",
        AG: "XCD",
        AF: "AFN",
        AI: "XCD",
        VI: "USD",
        IS: "ISK",
        IR: "IRR",
        AM: "AMD",
        AL: "ALL",
        AO: "AOA",
        AS: "USD",
        AR: "ARS",
        AU: "AUD",
        AT: "EUR",
        AW: "AWG",
        IN: "INR",
        AX: "EUR",
        AZ: "AZN",
        IE: "EUR",
        ID: "IDR",
        UA: "UAH",
        QA: "QAR",
        MZ: "MZN"
    };
    const currencyFormats = {
        "AED": {
            "money_format": "Dhs. {{amount}}",
            "money_with_currency_format": "Dhs. {{amount}} AED"
        },
        "AFN": {
            "money_format": "&#65;&#102; {{amount}}",
            "money_with_currency_format": "&#65;&#102; {{amount}} AFN"
        },
        "ALL": {
            "money_format": "Lek {{amount}}",
            "money_with_currency_format": "Lek {{amount}} ALL"
        },
        "AMD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} AMD"
        },
        "ANG": {
            "money_format": "&fnof;{{amount}}",
            "money_with_currency_format": "{{amount}} NA&fnof;"
        },
        "XCG": {
            "money_format": "Cg {{amount}}",
            "money_with_currency_format": "Cg {{amount}} XCG"
        },
        "AOA": {
            "money_format": "Kz{{amount}}",
            "money_with_currency_format": "Kz{{amount}} AOA"
        },
        "ARS": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
        },
        "AUD": {
            "money_format": "A${{amount}}",
            "money_with_currency_format": "${{amount}} AUD"
        },
        "AWG": {
            "money_format": "Afl{{amount}}",
            "money_with_currency_format": "Afl{{amount}} AWG"
        },
        "AZN": {
            "money_format": "&#8380;{{amount}}",
            "money_with_currency_format": "&#8380;{{amount}} AZN"
        },
        "BAM": {
            "money_format": "KM {{amount_with_comma_separator}}",
            "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
        },
        "BBD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} Bds"
        },
        "BDT": {
            "money_format": "Tk {{amount}}",
            "money_with_currency_format": "Tk {{amount}} BDT"
        },
        "BGN": {
            "money_format": "{{amount}} лв",
            "money_with_currency_format": "{{amount}} лв BGN"
        },
        "BHD": {
            "money_format": "{{amount}} BD",
            "money_with_currency_format": "{{amount}} BHD"
        },
        "BIF": {
            "money_format": "&#70;&#66;&#117; {{amount}}",
            "money_with_currency_format": "&#70;&#66;&#117; {{amount}} BIF"
        },
        "BMD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} BMD"
        },
        "BND": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} BND"
        },
        "BOB": {
            "money_format": "Bs{{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
        },
        "BRL": {
            "money_format": "R$ {{amount_with_comma_separator}}",
            "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
        },
        "BSD": {
            "money_format": "BS${{amount}}",
            "money_with_currency_format": "BS${{amount}} BSD"
        },
        "BTC": {
            "money_format": "{{amount_no_decimals}} BTC",
            "money_with_currency_format": "{{amount_no_decimals}} BTC"
        },
        "BTN": {
            "money_format": "Nu {{amount}}",
            "money_with_currency_format": "Nu {{amount}} BTN"
        },
        "BWP": {
            "money_format": "P{{amount}}",
            "money_with_currency_format": "P{{amount}} BWP"
        },
        "BYN": {
            "money_format": "Br {{amount}}",
            "money_with_currency_format": "Br {{amount}} BYN"
        },
        "BZD": {
            "money_format": "BZ${{amount}}",
            "money_with_currency_format": "BZ${{amount}} BZD"
        },
        "CAD": {
            "money_format": "C${{amount}}",
            "money_with_currency_format": "${{amount}} CAD"
        },
        "CDF": {
            "money_format": "&#70;&#67; {{amount}}",
            "money_with_currency_format": "&#70;&#67; {{amount}} CDF"
        },
        "CHF": {
            "money_format": "CHF {{amount}}",
            "money_with_currency_format": "CHF {{amount}}"
        },
        "CLP": {
            "money_format": "${{amount_no_decimals}}",
            "money_with_currency_format": "${{amount_no_decimals}} CLP"
        },
        "CNY": {
            "money_format": "&#165;{{amount}}",
            "money_with_currency_format": "&#165;{{amount}} CNY"
        },
        "COP": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} COP"
        },
        "CRC": {
            "money_format": "&#8353; {{amount_with_comma_separator}}",
            "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
        },
        "CUC": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} CUC"
        },
        "CUP": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} CUP"
        },
        "CVE": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} CVE"
        },
        "CZK": {
            "money_format": "{{amount_with_comma_separator}} K&#269;",
            "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
        },
        "DJF": {
            "money_format": "&#70;&#100;&#106; {{amount}}",
            "money_with_currency_format": "&#70;&#100;&#106; {{amount}} DJF"
        },
        "DKK": {
            "money_format": "kr {{amount_with_comma_separator}}",
            "money_with_currency_format": "kr {{amount_with_comma_separator}} DKK"
        },
        "DOP": {
            "money_format": "RD$ {{amount}}",
            "money_with_currency_format": "RD$ {{amount}}"
        },
        "DZD": {
            "money_format": "DA {{amount}}",
            "money_with_currency_format": "DA {{amount}} DZD"
        },
        "EEK": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} EEK"
        },
        "EGP": {
            "money_format": "LE {{amount}}",
            "money_with_currency_format": "LE {{amount}} EGP"
        },
        "ERN": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} ERN"
        },
        "ETB": {
            "money_format": "Br{{amount}}",
            "money_with_currency_format": "Br{{amount}} ETB"
        },
        "EUR": {
            "money_format": "&euro;{{amount_with_comma_separator}}",
            "money_with_currency_format": "&euro;{{amount_with_comma_separator}} EUR"
        },
        "FJD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "FJ${{amount}}"
        },
        "FKP": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} FKP"
        },
        "GBP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} GBP"
        },
        "GEL": {
            "money_format": "{{amount}} GEL",
            "money_with_currency_format": "{{amount}} GEL"
        },
        "GGP": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} GGP"
        },
        "GHS": {
            "money_format": "GH&#8373;{{amount}}",
            "money_with_currency_format": "GH&#8373;{{amount}}"
        },
        "GIP": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} GIP"
        },
        "GMD": {
            "money_format": "D {{amount}}",
            "money_with_currency_format": "D {{amount}} GMD"
        },
        "GNF": {
            "money_format": "&#70;&#71; {{amount}}",
            "money_with_currency_format": "&#70;&#71; {{amount}} GNF"
        },
        "GTQ": {
            "money_format": "Q{{amount}}",
            "money_with_currency_format": "{{amount}} GTQ"
        },
        "GYD": {
            "money_format": "G${{amount}}",
            "money_with_currency_format": "${{amount}} GYD"
        },
        "HKD": {
            "money_format": "HK${{amount}}",
            "money_with_currency_format": "HK${{amount}} HKD"
        },
        "HNL": {
            "money_format": "L {{amount}}",
            "money_with_currency_format": "L {{amount}} HNL"
        },
        "HRK": {
            "money_format": "{{amount_with_comma_separator}}  kn",
            "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
        },
        "HTG": {
            "money_format": "&#71; {{amount}}",
            "money_with_currency_format": "&#71; {{amount}} HTG"
        },
        "HUF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
        },
        "IDR": {
            "money_format": "{{amount_with_comma_separator}} IDR",
            "money_with_currency_format": "Rp {{amount_with_comma_separator}} IDR"
        },
        "ILS": {
            "money_format": "&#8362;{{amount}}",
            "money_with_currency_format": "&#8362;{{amount}} NIS"
        },
        "IMP": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} IMP"
        },
        "INR": {
            "money_format": "&#8377; {{amount}}",
            "money_with_currency_format": "&#8377; {{amount}} INR"
        },
        "IQD": {
            "money_format": "&#1593;.&#1583; {{amount}}",
            "money_with_currency_format": "&#1593;.&#1583; {{amount}} IQD"
        },
        "IRR": {
            "money_format": "&#65020; {{amount}}",
            "money_with_currency_format": "&#65020; {{amount}} IRR"
        },
        "ISK": {
            "money_format": "{{amount_no_decimals}} kr",
            "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
        },
        "JEP": {
            "money_format": "&pound;{{amount}}",
            "money_with_currency_format": "&pound;{{amount}} JEP"
        },
        "JMD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} JMD"
        },
        "JOD": {
            "money_format": "{{amount}} JD",
            "money_with_currency_format": "{{amount}} JOD"
        },
        "JPY": {
            "money_format": "&#165;{{amount_no_decimals}}",
            "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
        },
        "KES": {
            "money_format": "KSh{{amount}}",
            "money_with_currency_format": "KSh{{amount}}"
        },
        "KGS": {
            "money_format": "лв{{amount}}",
            "money_with_currency_format": "лв{{amount}}"
        },
        "KHR": {
            "money_format": "KHR{{amount}}",
            "money_with_currency_format": "KHR{{amount}}"
        },
        "KMF": {
            "money_format": "&#67;&#70; {{amount}}",
            "money_with_currency_format": "&#67;&#70; {{amount}} KMF"
        },
        "KPW": {
            "money_format": "&#8361; {{amount}}",
            "money_with_currency_format": "&#8361; {{amount}} KPW"
        },
        "KRW": {
            "money_format": "&#8361;{{amount_no_decimals}}",
            "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
        },
        "KWD": {
            "money_format": "{{amount}} KD",
            "money_with_currency_format": "{{amount}} KWD"
        },
        "KYD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} KYD"
        },
        "KZT": {
            "money_format": "{{amount}} KZT",
            "money_with_currency_format": "{{amount}} KZT"
        },
        "LAK": {
            "money_format": "&#8365; {{amount}}",
            "money_with_currency_format": "&#8365; {{amount}} LAK"
        },
        "LBP": {
            "money_format": "L.L.{{amount}}",
            "money_with_currency_format": "L.L.{{amount}} LBP"
        },
        "LKR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} LKR"
        },
        "LRD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} LRD"
        },
        "LSL": {
            "money_format": "&#76; {{amount}}",
            "money_with_currency_format": "&#76; {{amount}} LSL"
        },
        "LTL": {
            "money_format": "{{amount}} Lt",
            "money_with_currency_format": "{{amount}} Lt"
        },
        "LVL": {
            "money_format": "Ls {{amount}}",
            "money_with_currency_format": "Ls {{amount}} LVL"
        },
        "LYD": {
            "money_format": "&#1604;.&#1583; {{amount}}",
            "money_with_currency_format": "&#1604;.&#1583; {{amount}} LYD"
        },
        "MAD": {
            "money_format": "{{amount}} dh",
            "money_with_currency_format": "Dh {{amount}} MAD"
        },
        "MDL": {
            "money_format": "{{amount}} MDL",
            "money_with_currency_format": "{{amount}} MDL"
        },
        "MGA": {
            "money_format": "Ar {{amount}}",
            "money_with_currency_format": "Ar {{amount}} MGA"
        },
        "MKD": {
            "money_format": "ден {{amount}}",
            "money_with_currency_format": "ден {{amount}} MKD"
        },
        "MMK": {
            "money_format": "K{{amount}}",
            "money_with_currency_format": "K{{amount}} MMK"
        },
        "MNT": {
            "money_format": "{{amount_no_decimals}} &#8366",
            "money_with_currency_format": "{{amount_no_decimals}} MNT"
        },
        "MOP": {
            "money_format": "MOP${{amount}}",
            "money_with_currency_format": "MOP${{amount}}"
        },
        "MRO": {
            "money_format": "&#85;&#77; {{amount}}",
            "money_with_currency_format": "&#85;&#77; {{amount}} MRO"
        },
        "MUR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} MUR"
        },
        "MVR": {
            "money_format": "Rf{{amount}}",
            "money_with_currency_format": "Rf{{amount}} MVR"
        },
        "MWK": {
            "money_format": "&#77;&#75; {{amount}}",
            "money_with_currency_format": "&#77;&#75; {{amount}} MWK"
        },
        "MXN": {
            "money_format": "$ {{amount}}",
            "money_with_currency_format": "$ {{amount}} MXN"
        },
        "MYR": {
            "money_format": "RM{{amount}}",
            "money_with_currency_format": "RM{{amount}} MYR"
        },
        "MZN": {
            "money_format": "{{amount}} Mt",
            "money_with_currency_format": "Mt {{amount}} MZN"
        },
        "NAD": {
            "money_format": "N${{amount}}",
            "money_with_currency_format": "N${{amount}} NAD"
        },
        "NGN": {
            "money_format": "&#8358;{{amount}}",
            "money_with_currency_format": "&#8358;{{amount}} NGN"
        },
        "NIO": {
            "money_format": "C${{amount}}",
            "money_with_currency_format": "C${{amount}} NIO"
        },
        "NOK": {
            "money_format": "kr {{amount_with_comma_separator}}",
            "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
        },
        "NPR": {
            "money_format": "Rs{{amount}}",
            "money_with_currency_format": "Rs{{amount}} NPR"
        },
        "NZD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} NZD"
        },
        "OMR": {
            "money_format": "{{amount}} OMR",
            "money_with_currency_format": "{{amount}} OMR"
        },
        "PAB": {
            "money_format": "&#66;&#47;&#46; {{amount}}",
            "money_with_currency_format": "&#66;&#47;&#46; {{amount}} PAB"
        },
        "PEN": {
            "money_format": "S/. {{amount}}",
            "money_with_currency_format": "S/. {{amount}} PEN"
        },
        "PGK": {
            "money_format": "K {{amount}}",
            "money_with_currency_format": "K {{amount}} PGK"
        },
        "PHP": {
            "money_format": "&#8369;{{amount}}",
            "money_with_currency_format": "&#8369;{{amount}} PHP"
        },
        "PKR": {
            "money_format": "Rs.{{amount}}",
            "money_with_currency_format": "Rs.{{amount}} PKR"
        },
        "PLN": {
            "money_format": "{{amount_with_comma_separator}} zl",
            "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
        },
        "PYG": {
            "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
        },
        "QAR": {
            "money_format": "QAR {{amount_with_comma_separator}}",
            "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
        },
        "RON": {
            "money_format": "{{amount_with_comma_separator}} lei",
            "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
        },
        "RSD": {
            "money_format": "{{amount}} RSD",
            "money_with_currency_format": "{{amount}} RSD"
        },
        "RUB": {
            "money_format": "&#8381; {{amount_with_comma_separator}}",
            "money_with_currency_format": "&#8381; {{amount_with_comma_separator}} RUB"
        },
        "RWF": {
            "money_format": "{{amount_no_decimals}} RF",
            "money_with_currency_format": "{{amount_no_decimals}} RWF"
        },
        "SAR": {
            "money_format": "{{amount}} SR",
            "money_with_currency_format": "{{amount}} SAR"
        },
        "SBD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} SBD"
        },
        "SCR": {
            "money_format": "Rs {{amount}}",
            "money_with_currency_format": "Rs {{amount}} SCR"
        },
        "SDG": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} SDG"
        },
        "SEK": {
            "money_format": "kr {{amount_no_decimals}}",
            "money_with_currency_format": "kr {{amount_no_decimals}} SEK"
        },
        "SGD": {
            "money_format": "S${{amount}}",
            "money_with_currency_format": "S${{amount}} SGD"
        },
        "SHP": {
            "money_format": "&#163; {{amount}}",
            "money_with_currency_format": "&#163; {{amount}} SHP"
        },
        "SKK": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} SKK"
        },
        "SLL": {
            "money_format": "&#76;&#101; {{amount}}",
            "money_with_currency_format": "&#76;&#101; {{amount}} SLL"
        },
        "SOS": {
            "money_format": "&#83; {{amount}}",
            "money_with_currency_format": "&#83; {{amount}} SOS"
        },
        "SPL": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} SPL"
        },
        "SRD": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} SRD"
        },
        "STD": {
            "money_format": "Db {{amount}}",
            "money_with_currency_format": "Db {{amount}} STD"
        },
        "SVC": {
            "money_format": "&#36; {{amount}}",
            "money_with_currency_format": "&#36; {{amount}} SVC"
        },
        "SYP": {
            "money_format": "S&pound;{{amount}}",
            "money_with_currency_format": "S&pound;{{amount}} SYP"
        },
        "SZL": {
            "money_format": "&#76; {{amount}}",
            "money_with_currency_format": "&#76; {{amount}} SZL"
        },
        "THB": {
            "money_format": "{{amount}} &#xe3f;",
            "money_with_currency_format": "{{amount}} &#xe3f; THB"
        },
        "TJS": {
            "money_format": "&#84;&#74;&#83; {{amount}}",
            "money_with_currency_format": "&#84;&#74;&#83; {{amount}} TJS"
        },
        "TMT": {
            "money_format": "&#109; {{amount}}",
            "money_with_currency_format": "&#109; {{amount}} TMT"
        },
        "TND": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} DT"
        },
        "TOP": {
            "money_format": "&#84;&#36; {{amount}}",
            "money_with_currency_format": "&#84;&#36; {{amount}} TOP"
        },
        "TRY": {
            "money_format": "{{amount}} TL",
            "money_with_currency_format": "{{amount}} TL"
        },
        "TTD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TTD"
        },
        "TVD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} TVD"
        },
        "TWD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} TWD"
        },
        "TZS": {
            "money_format": "{{amount}} TZS",
            "money_with_currency_format": "{{amount}} TZS"
        },
        "UAH": {
            "money_format": "₴{{amount}}",
            "money_with_currency_format": "₴{{amount}} UAH"
        },
        "UGX": {
            "money_format": "Ush {{amount_no_decimals}}",
            "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
        },
        "USD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}} USD"
        },
        "UYU": {
            "money_format": "${{amount_with_comma_separator}}",
            "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
        },
        "UZS": {
            "money_format": "&#1083;&#1074; {{amount}}",
            "money_with_currency_format": "&#1083;&#1074; {{amount}} UZS"
        },
        "VES": {
            "money_format": "Bs. {{amount_with_comma_separator}}",
            "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VES"
        },
        "VND": {
            "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
        },
        "VUV": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "${{amount}}VT"
        },
        "WST": {
            "money_format": "WS$ {{amount}}",
            "money_with_currency_format": "WS$ {{amount}} WST"
        },
        "XAF": {
            "money_format": "FCFA{{amount}}",
            "money_with_currency_format": "FCFA{{amount}} XAF"
        },
        "XAG": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XAG"
        },
        "XAU": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XAU"
        },
        "XCD": {
            "money_format": "${{amount}}",
            "money_with_currency_format": "EC${{amount}}"
        },
        "XDR": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XDR"
        },
        "XOF": {
            "money_format": "CFA{{amount}}",
            "money_with_currency_format": "CFA{{amount}} XOF"
        },
        "XPD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XPD"
        },
        "XPF": {
            "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
            "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
        },
        "XPT": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} XPT"
        },
        "YER": {
            "money_format": "&#65020; {{amount}}",
            "money_with_currency_format": "&#65020; {{amount}} YER"
        },
        "ZAR": {
            "money_format": "R {{amount}}",
            "money_with_currency_format": "R {{amount}} ZAR"
        },
        "ZMW": {
            "money_format": "K{{amount_no_decimals_with_comma_separator}}",
            "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
        },
        "ZWD": {
            "money_format": "{{amount}}",
            "money_with_currency_format": "{{amount}} ZWD"
        }
    };
    
    class CountriesSelector extends HTMLElement {
        constructor() {
            super();

            this.flag = false;
            this.currencyRateMap = null;
            this.country = 'US';
            this.currency = "USD";
            this.currencyRate = 1.0;
            this.countrySelectedEl = this.querySelector('.countries-selected');
            this.countriesItmList = this.querySelectorAll('.countries-item');
        }

        connectedCallback() {
            fetch(`${apiHost}/api/rate/list`, {
                "method": "get",
                "headers": { "Content-Type": "application/json" },
            })
            .then(response => response.json())
            .then(data => {
                if (data.status == 'ok') {
                    this.currencyRateMap = data.result;
                }
            })
            .catch(error => console.error(error))
            .finally(() => {
                this.init();
            });
        }

        init() {
            this.addEvent();

            this.domReady(() => {
                if (!this.currencyRateMap) return;
                
                if (curent_country) this.country = curent_country;
                const currency = cmap[`${this.country}`];
                const currencyRate = this.currencyRateMap[`${currency}`];

                if (!this.flag && Shopify.country) {
                    const code2 = Shopify.country.toLowerCase();
                    const autoLcationEl = this.querySelector('.countries-item.geo-currency');
                    autoLcationEl.querySelector('.countries-icon').src = `${apiHost}/countries/${code2}.svg`;
                    autoLcationEl.dataset.currency = cmap[`${Shopify.country}`];
                    autoLcationEl.dataset.code = code2;
                }
 
                this.initDom(currency, currencyRate, this.country.toLocaleLowerCase());
                
                this.flag = true;
            });
        }

        initDom(currency, currencyRate, code) {
            this.currency = currency;
            this.currencyRate = currencyRate;
            this.moneyCurrencyFormat = currencyFormats[`${this.currency}`]["money_format"];

            window.moneyCurrency = this.currency;
            window.moneyCurrencyFormat = this.moneyCurrencyFormat;
            window.moneyCrrencyRate = this.currencyRate;
            this.resetDefaultDom(this.currency, code);
            this.initAllMoneySelector();
        }

        addEvent() {
            this.countrySelectedEl.addEventListener('click', (e) => {
                const targetEl = e.currentTarget;
                if (targetEl.parentNode.classList.contains('active')) {
                    targetEl.parentNode.classList.remove('active');
                } else {
                    targetEl.parentNode.classList.add('active');
                }
            });
            this.countriesItmList.forEach((item) => {
                item.addEventListener('click', (e) => {
                    if (this.flag) {
                        const targetEl = e.currentTarget;
                        const currency = targetEl.dataset.currency;
                        const cuounry = targetEl.dataset.code;
                        const currencyRate = this.currencyRateMap[`${currency}`];
                        this.initDom(currency, currencyRate, cuounry);
                        window.localStorage.setItem('country', cuounry);
                    }
                    this.classList.remove('active');
                });
            });

            window.addEventListener('click', (e)=> {
                if (!this.contains(e.target) && this.classList.contains('active')) {
                    this.classList.remove('active');
                }
            });
        }

        resetDefaultDom(currency, code) {
            this.countrySelectedEl.querySelector('.countries-icon').src = `${apiHost}/countries/${code}.svg`;
            this.countrySelectedEl.querySelector('.countries-currency').innerText = currency;
        }

        initAllMoneySelector() {
            const allMoneyEl = document.querySelectorAll('span.money, .fmoney');
            allMoneyEl.forEach((moneyEl) => {
                const originalMoney = !this.flag ? (moneyEl.innerText || moneyEl.textContent).trim() : moneyEl.getAttribute('rate-original').trim();                        
                const initMoney = originalMoney ? originalMoney.replace(/[^0-9.]/g, '') : '0.00';
                
                if (!this.flag) {
                  moneyEl.classList.add('rate-money');
                  moneyEl.setAttribute('rate-original', originalMoney);
                  moneyEl.setAttribute('rate-init', initMoney);
                }
                moneyEl.setAttribute('rate-currency', this.currency);

                const newMoney = parseFloat(initMoney) * this.currencyRate;
                moneyEl.innerHTML = ( (moneyEl.getAttribute('rate-original').indexOf('From') > -1 ? "From " : "") + this.moneyCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, newMoney.toFixed(2)) );
            });
        }

        domReady(callback) {
            if (document.readyState != 'loading') callback();
            else document.addEventListener('DOMContentLoaded', callback);
        }
    }
    customElements.define('countries-selector', CountriesSelector);
}